import React from 'react';
import { useTranslation } from 'react-i18next';
import { ADMIN_PAGES_KEYS, NS } from '../../../../../../i18n/constants/keys';
import { LoadingOverlay } from '../../../../../../ui/components/Common/DataTable/Conmponents/LoadingOverlay';
import { CandidateDetails } from './Components/CandiateDetais';
import { EmptyState, ErrorFallback } from './Components/EmptyState';
import { UserSelection } from './Components/UserSelection';
import { useOffer } from './Hooks/UseOffer';

export interface IOffer {
  jobOpeningId: string;
}

// Error Fallback Component

export const Offer = ({ jobOpeningId }: IOffer) => {
  const { t } = useTranslation(NS.adminPages);
  const SI = ADMIN_PAGES_KEYS.jobOpenings.smartInterviews;
  const {
    candidates,
    isLoading,
    error,
    selectedCandidate,
    selectedCandidateId,
    getStatusColor,
    getUserInitials,
    totalCandidates,
    setSelectedCandidateId,
    limit,
    page,
    setPage,
    setCandidates,
    updateCandidateOfferStatus,
    isUpdatingStatus,
    addCandidatesFromPreviousRound,
  } = useOffer({
    jobOpeningId,
  });

  return (
    <div className='grid lg:grid-cols-8 bg-primary-background p-4 gap-4'>
      { isLoading ? (
        <LoadingOverlay />
      ) : error ? (
        <ErrorFallback error={error} />
      ) : candidates.length === 0 ? (
        <EmptyState
            jobOpeningId={jobOpeningId}
            addCandidatesFromPreviousRound={addCandidatesFromPreviousRound}
        />
      ) : (
        <div className='col-span-full'>
          { /* Avatars Section */ }
          <UserSelection
              candidates={candidates}
              selectedCandidateId={selectedCandidateId}
              setSelectedCandidateId={setSelectedCandidateId}
              totalCandidates={totalCandidates}
              getStatusColor={getStatusColor}
              getUserInitials={getUserInitials}
              selectedCandidate={selectedCandidate}
              jobOpeningId={jobOpeningId}
              setCandidates={setCandidates}
              addCandidatesFromPreviousRound={addCandidatesFromPreviousRound}
              limit={limit}
              page={page}
              onPreviousPageChange={setPage}
              onNextPageChange={setPage}
          />
          { /* Details Section */ }
          { selectedCandidate ? (
            <CandidateDetails
                selectedCandidate={selectedCandidate}
                isUpdatingStatus={isUpdatingStatus}
                updateCandidateOfferStatus={updateCandidateOfferStatus}
            />
          ) : (
            <div className='col-span-full bg-white rounded-3xl shadow-lg border border-gray-200 p-8 text-center'>
              <p className='text-gray-500'>
                { t(SI.offer.selectCandidate) }
              </p>
            </div>
          ) }
          { /* Pagination controls */ }
        </div>
      ) }
    </div>
  );
};
